import { render } from "./OptionsPageSearch.vue?vue&type=template&id=c50fbb7c"
import script from "./OptionsPageSearch.vue?vue&type=script&lang=js"
export * from "./OptionsPageSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__